import React from "react";

const ScoreboardIndex = ({ routes, t }) => {
  return (
    <div className="scoreboard-index">
      <div className="container-fluid d-flex justify-content-center align-items-center min-vh-100">
        <div className="text-center">
          <h1 className="scoreboard-index-title mb-4">
            {t.title}
          </h1>
          <p className="scoreboard-index-subtitle mb-5">
            {t.subtitle}
          </p>
          <div className="alert alert-info">
            <i className="fa-solid fa-info-circle me-2"></i>
            {t.select_competition}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoreboardIndex;